module.exports = __webpack_public_path__ + "public/files/img/file.1e48f1c5.png";